import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@projectobelisk/uikit/components/feedback/empty";
import { createFileRoute } from "@tanstack/react-router";
import { Workflow } from "lucide-react";

export const Route = createFileRoute("/_app/speed-to-lead/pipeline")({
  staticData: { title: "Pipeline", breadcrumb: "Pipeline" },
  component: Pipeline,
});

function Pipeline() {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Workflow />
        </EmptyMedia>
        <EmptyTitle>No leads pipeline yet</EmptyTitle>
        <EmptyDescription>
          Create your first campaign to start tracking lead progression.
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
